import api from './api';

const register = async (userData) => {
    try {
        const response = await api.post('/auth/register', userData);
        console.log('Register response:', response.data);
        
        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    } catch (error) {
        console.error('Register service error:', error);
        throw error;
    }
};

const login = async (userData) => {
    try {
        const response = await api.post('/auth/login', userData);
        console.log('Login response:', response.data);
        
        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    } catch (error) {
        console.error('Login service error:', error);
        throw error;
    }
};

// Single-device login: tell the server to invalidate this token (bumps
// tokenVersion) before clearing local storage, so "Logout" actually has a
// server-side effect for the first time instead of leaving the token valid
// until its natural expiry. The API call is best-effort — if it fails
// (network issue, token already invalid, etc.) localStorage is still
// cleared regardless, since a logout must never get stuck.
const logout = async () => {
    try {
        await api.post('/auth/logout');
    } catch (error) {
        console.error('Logout API error (ignored, clearing session locally anyway):', error.message);
    }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

const verifyOtp = async (email, otp) => {
    try {
        const response = await api.post('/auth/verify-otp', { email, otp });
        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    } catch (error) {
        console.error('Verify OTP service error:', error);
        throw error;
    }
};

const resendOtp = async (email) => {
    try {
        const response = await api.post('/auth/resend-otp', { email });
        return response.data;
    } catch (error) {
        console.error('Resend OTP service error:', error);
        throw error;
    }
};

const getProfile = async () => {
    try {
        const response = await api.get('/auth/profile');
        return response.data;
    } catch (error) {
        console.error('Get profile error:', error);
        throw error;
    }
};

const getCurrentUser = () => {
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    
    if (user && token) {
        return JSON.parse(user);
    }
    return null;
};

const authService = {
    register,
    login,
    logout,
    getProfile,
    getCurrentUser,
    verifyOtp,
    resendOtp,
};

export default authService;